module.exports = __webpack_public_path__ + "img/lpf_icon.ae48af9f.png";